import React, { useState } from "react";
import { Link } from "react-router-dom";
import { NavigationPanelListItemType } from "../../types/components";
import ChevronRight from "../../assets/images/icons/rebrand/chevron-right.svg";
import { trackEvent } from "../../services/eventTracker";
import useErrorModal from "../../hooks/useErrorModal";
import { FEATURE_FLAGS, RR_SDK_FEATURE_FLAGS } from "../../constants/featureFlags";

import MyCardDirectiveModal from "../MyCard/MyCardDirectiveModal";
import SpinningLoader from "../Common/SpinningLoader";
import useGetRRAuthData from "../../hooks/useGetRRAuthData";

const NavigationPanelListItem = ({ data, featureFlags, includeIconSpacing = false }: {
  data: NavigationPanelListItemType,
  featureFlags?: string[],
  includeIconSpacing?: boolean
}) => {
  const { title, subtitle, icon, badge, link, featureFlag, event, modal,
    getRRAuth, rsp, transferMethod, onClick } = data;
  const isInteractive = Boolean(link || modal || onClick);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const openErrorModal = useErrorModal();
  const getRRAuthData = useGetRRAuthData({ setLoading, openErrorModal });

  if (featureFlag) {
    const flagEnabled = featureFlags?.includes(featureFlag);
    const sdkKillswitched =
      RR_SDK_FEATURE_FLAGS.includes(featureFlag) &&
      featureFlags?.includes(FEATURE_FLAGS.RR_WEB_SDK_KILLSWITCH);

    if (!flagEnabled || sdkKillswitched) {
      return null;
    }
  }

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (event) {
      if (event.param) {
        trackEvent(event.name, {
          [event.param.name]: event.param.value
        })
      } else {
        trackEvent(event.name);
      }
    }

    if (getRRAuth && rsp && transferMethod) {
      e.preventDefault();
      getRRAuthData(rsp, transferMethod as string);
    }

    if (onClick) {
      e.preventDefault();
      onClick(e);
    }

    if (modal) {
      e.preventDefault();
      setOpen(true);
    }
  }

  const renderChildren = () => {
    return (
      <div>
        <p className={`font-size-lg text-primary ${subtitle ? "bold spacing-bottom-xs" : "spacing-bottom-none"}`}>{title} {badge && <span className="badge">{badge}</span>} </p>
        {subtitle && <p className="text-secondary spacing-bottom-none">{subtitle}</p>}
      </div>
    );
  }

  const spacingStrategies = {
    withMarginLeft: () => "spacing-left-large-medium",
    withPadding: () => "padding-left-small padding-right-small",
    default: () => "",
  };

  const getSpacingClassName = (() => {
    if (includeIconSpacing && !icon) return spacingStrategies.withMarginLeft;
    if (!includeIconSpacing) return spacingStrategies.withPadding;
    return spacingStrategies.default;
  })();

  return (
    <li className={`flex-row align-items-start bg-color-white ${getSpacingClassName()}`}>
      {icon &&
        <div className={`min-w-40`}>
          {icon && <img src={icon} alt={title} />}
        </div>
      }

      {isInteractive &&
        <Link
          to={link || "#"}
          className={`flex-row justify-content-between align-items-center col-flex-1`}
          onClick={handleClick}
        >
          {renderChildren()}

          <img src={ChevronRight} alt="Chevron Right" />

          {modal &&
            <MyCardDirectiveModal
              open={open}
              setOpen={setOpen}
              modalData={modal}
            />
          }
        </Link>
      }

      {(!isInteractive) &&
        <div className="inline-table">{renderChildren()}</div>
      }

      <SpinningLoader show={loading} />
    </li>
  );
}

export default NavigationPanelListItem;